module.exports = __webpack_public_path__ + "static/img/purchase_order.66d26a91.svg";